import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { Button, message } from 'antd';
import MuiIconButton from 'material-ui/IconButton';
import MuiButton from 'material-ui/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import localForage from 'localforage';

import BizCard from '../../components/UI/BizCard';
import BizInput from '../../components/UI/BizInput';
import BizSelect from '../../components/UI/BizSelect';
import S3Upload from '../../components/S3Upload';
import FormFloatingButtons from '../../components/FormFloatingButtons';

import { natureOfChargeOptions, removeTypenameFromArrays } from '../../utils/globals';

import MUTATION from '../../graphql/mutations/ldsFisMutation.graphql';

const DeleteFormRowButton = (props) => (
  <MuiIconButton
    aria-label="Delete"
    onClick={props.onClick}
    style={{ width: 30, height: 30 }}
  >
    <DeleteIcon />
  </MuiIconButton>
);
DeleteFormRowButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

const localForageItemkey = (cid) => (`${cid}_ldsFis`);

const initialState = ({ movableSecurities, immovableSecurities, queries }) => ({
  movableSecurities,
  immovableSecurities,
  queries: removeTypenameFromArrays(queries.map((entry) => ({ ...entry, reply: '' }))),
  startedAt: new Date().toISOString(),
});

class LdsFis extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState(props.fis),
    };
  }

  componentDidMount() {
    localForage.getItem(localForageItemkey(this.props.match.params.cid))
      .then((value) => {
        if (value) {
          this.setState({
            ...value,
          });
        }
      });
  }

  clearForm = () => {
    localForage.removeItem(localForageItemkey(this.props.match.params.cid));
    this.setState({
      ...initialState(this.props.fis),
    });
  };

  saveData = () => {
    const { additionalStates, ...data } = this.state;
    localForage.setItem(localForageItemkey(this.props.match.params.cid), data)
      .then(() => {
        message.success('Saved!');
      })
      .catch(() => {
        message.error('Not Saved!');
      });
  };

  handleArrayFormValue = (arrayName, id, key, value) => {
    this.setState({
      [arrayName]: this.state[arrayName].map((entry) => {
        if (entry.id === id) {
          return { ...entry, [key]: value };
        }
        return entry;
      }),
    });
  };

  removeFormRow = (stateObjKey, id) => {
    this.setState({
      [stateObjKey]: this.state[stateObjKey].filter((entry) => (entry.id !== id)),
    });
  };

  immovableSecuritiesRow = (entry) => (
    <tr key={entry.id}>
      <td>
        <div>
          <BizInput
            type="textarea"
            theme="lac"
            name={`immovableSecurities[${entry.id}][address]`}
            onChange={(value) => { this.handleArrayFormValue('immovableSecurities', entry.id, 'address', value); }}
            value={entry.address}
            placeholder="Street Address"
          />
        </div>
        <div>
          <BizInput
            theme="lac"
            name={`immovableSecurities[${entry.id}][city]`}
            onChange={(value) => { this.handleArrayFormValue('immovableSecurities', entry.id, 'city', value); }}
            value={entry.city}
            placeholder="City"
          />
        </div>
        <div>
          <BizInput
            theme="lac"
            name={`immovableSecurities[${entry.id}][state]`}
            onChange={(value) => { this.handleArrayFormValue('immovableSecurities', entry.id, 'state', value); }}
            value={entry.state}
            placeholder="State"
          />
        </div>
        <div>
          <BizInput
            theme="lac"
            name={`immovableSecurities[${entry.id}][pincode]`}
            onChange={(value) => { this.handleArrayFormValue('immovableSecurities', entry.id, 'pincode', value); }}
            value={entry.pincode}
            placeholder="Pincode"
          />
        </div>
      </td>
      <td>
        <BizInput
          theme="lac"
          name={`immovableSecurities[${entry.id}][propertyType]`}
          onChange={(value) => { this.handleArrayFormValue('immovableSecurities', entry.id, 'propertyType', value); }}
          value={entry.propertyType}
        />
      </td>
      <td>
        <BizInput
          theme="lac"
          name={`immovableSecurities[${entry.id}][ownedBy]`}
          onChange={(value) => { this.handleArrayFormValue('immovableSecurities', entry.id, 'ownedBy', value); }}
          value={entry.ownedBy}
        />
      </td>
      <td>
        <BizInput
          type="number"
          theme="lac"
          name={`immovableSecurities[${entry.id}][plotArea]`}
          onChange={(value) => { this.handleArrayFormValue('immovableSecurities', entry.id, 'plotArea', value); }}
          value={entry.plotArea}
        />
      </td>
      <td>
        <BizInput
          type="number"
          theme="lac"
          name={`immovableSecurities[${entry.id}][constructionArea]`}
          onChange={(value) => { this.handleArrayFormValue('immovableSecurities', entry.id, 'constructionArea', value); }}
          value={entry.constructionArea}
        />
      </td>
      <td>
        <BizInput
          type="number"
          theme="lac"
          name={`immovableSecurities[${entry.id}][marketValue]`}
          onChange={(value) => { this.handleArrayFormValue('immovableSecurities', entry.id, 'marketValue', value); }}
          value={entry.marketValue}
        />
      </td>
      <td>
        <BizInput
          theme="lac"
          name={`immovableSecurities[${entry.id}][product]`}
          onChange={(value) => { this.handleArrayFormValue('immovableSecurities', entry.id, 'product', value); }}
          value={entry.product}
        />
      </td>
      <td>
        <BizSelect
          name={`immovableSecurities[${entry.id}][chargeNature]`}
          onChange={(value) => { this.handleArrayFormValue('immovableSecurities', entry.id, 'chargeNature', value); }}
          value={entry.chargeNature}
          options={natureOfChargeOptions}
          theme="lac"
        />
      </td>
      <td>
        <DeleteFormRowButton onClick={() => { this.removeFormRow('immovableSecurities', entry.id); }} />
      </td>
    </tr>
  );

  immovableSecurityNewBtn = (type) => (
    <Button
      onClick={() => {
        this.setState({
          immovableSecurities: [...this.state.immovableSecurities, {
            id: (+new Date()).toString(36),
            type,
            address: '',
            city: '',
            state: '',
            pincode: '',
            propertyType: '',
            ownedBy: '',
            plotArea: 0,
            constructionArea: 0,
            marketValue: 0,
            product: '',
            chargeNature: null,
          }],
        });
      }}
    >
      Add new
    </Button>
  );

  movableSecuritiesRow = (entry) => (
    <tr key={entry.id}>
      <td>
        <BizInput
          type="textarea"
          textareaRows={2}
          theme="lac"
          name={`movableSecurities[${entry.id}][details]`}
          onChange={(value) => { this.handleArrayFormValue('movableSecurities', entry.id, 'details', value); }}
          value={entry.details}
        />
      </td>
      <td>
        <BizInput
          type="number"
          theme="lac"
          name={`movableSecurities[${entry.id}][marketValue]`}
          onChange={(value) => { this.handleArrayFormValue('movableSecurities', entry.id, 'marketValue', value); }}
          value={entry.marketValue}
        />
      </td>
      <td>
        <BizInput
          theme="lac"
          name={`movableSecurities[${entry.id}][product]`}
          onChange={(value) => { this.handleArrayFormValue('movableSecurities', entry.id, 'product', value); }}
          value={entry.product}
        />
      </td>
      <td>
        <BizSelect
          name={`movableSecurities[${entry.id}][chargeNature]`}
          onChange={(value) => { this.handleArrayFormValue('movableSecurities', entry.id, 'chargeNature', value); }}
          value={entry.chargeNature}
          options={natureOfChargeOptions}
          theme="lac"
        />
      </td>
      <td>
        <DeleteFormRowButton onClick={() => { this.removeFormRow('movableSecurities', entry.id); }} />
      </td>
    </tr>
  );

  movableSecuritiesNewBtn = (type) => (
    <Button
      onClick={() => {
        this.setState({
          movableSecurities: [...this.state.movableSecurities, {
            id: (+new Date()).toString(36),
            type,
            details: '',
            marketValue: 0,
            product: '',
            chargeNature: null,
          }],
        });
      }}
    >
      Add new
    </Button>
  );

  handleFormSubmit = () => {
    const { additionalStates, ...args } = this.state;
    const customerId = this.props.match.params.cid;

    this.props.mutate({
      variables: {
        customerId,
        ...args,
      },
    })
      .then(() => {
        message.success('Success!');
        this.clearForm();
        this.props.history.push(`/app/lead/${customerId}`);
      })
      .catch((mutateErr) => {
        message.error(mutateErr.message);
      });
  };

  render() {
    const {
      immovableSecurities,
      movableSecurities,
      queries,
    } = this.state;

    const { docs } = this.props;
    const { securitiesRequested, docsIds } = this.props.fis;

    return (
      <BizCard title="Further Information Sheet">
        <FormFloatingButtons handleSave={this.saveData} handleClear={this.clearForm} />
        <table className="biz-form-table">
          <tbody>
            {/* Primary Immovable Security */}
            {
              securitiesRequested ?
                <tr>
                  <td className="biz-form-table-label">Primary Immovable Security</td>
                  <td className="biz-form-table-input">
                    <table className="biz-data-table biz-bordered">
                      <thead>
                        <tr>
                          <th>Address</th>
                          <th>Property Type</th>
                          <th>Owned By</th>
                          <th>Plot Area</th>
                          <th>Construction Area</th>
                          <th>Market Value</th>
                          <th>Product</th>
                          <th>Nature of Charge</th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        {
                          immovableSecurities.filter((element) => (element.type === 'primary')).map((entry) => (
                            this.immovableSecuritiesRow(entry)
                          ))
                        }
                      </tbody>
                    </table>
                  </td>
                  <td className="biz-form-table-action">
                    {
                      this.immovableSecurityNewBtn('primary')
                    }
                  </td>
                </tr>
                :
                null
            }

            {/* Collateral Immovable Security */}
            {
              securitiesRequested ?
                <tr>
                  <td className="biz-form-table-label">Collateral Immovable Security</td>
                  <td className="biz-form-table-input">
                    <table className="biz-data-table biz-bordered">
                      <thead>
                        <tr>
                          <th>Address</th>
                          <th>Property Type</th>
                          <th>Owned By</th>
                          <th>Plot Area</th>
                          <th>Construction Area</th>
                          <th>Market Value</th>
                          <th>Product</th>
                          <th>Nature of Charge</th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        {
                          immovableSecurities.filter((element) => (element.type === 'collateral')).map((entry) => (
                            this.immovableSecuritiesRow(entry)
                          ))
                        }
                      </tbody>
                    </table>
                  </td>
                  <td className="biz-form-table-action">
                    {
                      this.immovableSecurityNewBtn('collateral')
                    }
                  </td>
                </tr>
                :
                null
            }

            {/* Primary - Movable */}
            {
              securitiesRequested ?
                <tr>
                  <td className="biz-form-table-label">Primary Movable Security</td>
                  <td className="biz-form-table-input">
                    <table className="biz-data-table biz-bordered">
                      <thead>
                        <tr>
                          <th>Particulars</th>
                          <th>Market Value</th>
                          <th>Product</th>
                          <th>Nature of Charge</th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        {
                          movableSecurities.filter((element) => (element.type === 'primary')).map((entry) => (
                            this.movableSecuritiesRow(entry)
                          ))
                        }
                      </tbody>
                    </table>
                  </td>
                  <td className="biz-form-table-action">
                    {
                      this.movableSecuritiesNewBtn('primary')
                    }
                  </td>
                </tr>
                :
                null
            }

            {/* Collateral - Movable */}
            {
              securitiesRequested ?
                <tr>
                  <td className="biz-form-table-label">Collateral Movable Security</td>
                  <td className="biz-form-table-input">
                    <table className="biz-data-table biz-bordered">
                      <thead>
                        <tr>
                          <th>Particulars</th>
                          <th>Market Value</th>
                          <th>Product</th>
                          <th>Nature of Charge</th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        {
                          movableSecurities.filter((element) => (element.type === 'collateral')).map((entry) => (
                            this.movableSecuritiesRow(entry)
                          ))
                        }
                      </tbody>
                    </table>
                  </td>
                  <td className="biz-form-table-action">
                    {
                      this.movableSecuritiesNewBtn('collateral')
                    }
                  </td>
                </tr>
                :
                null
            }

            {/* Queries */}
            {
              queries && queries.length > 0 ?
                <tr>
                  <td className="biz-form-table-label">Queries</td>
                  <td className="biz-form-table-input">
                    <table className="biz-data-table biz-bordered">
                      <thead>
                        <tr>
                          <th>Query</th>
                          <th>Reply</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          queries.map((entry) => (
                            <tr key={entry.id}>
                              <td>{entry.query}</td>
                              <td>
                                <BizInput
                                  type="textarea"
                                  textareaRows={2}
                                  theme="lac"
                                  name={`queries[${entry.id}][reply]`}
                                  onChange={(value) => { this.handleArrayFormValue('queries', entry.id, 'reply', value); }}
                                  value={entry.reply}
                                />
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                  </td>
                  <td className="biz-form-table-action" />
                </tr>
                :
                null
            }

            {/* Documents to be uploaded */}
            {
              docsIds.length > 0 ?
                <tr>
                  <td className="biz-form-table-label">Documents to be uploaded</td>
                  <td className="biz-form-table-input">
                    <table className="biz-data-table biz-bordered">
                      <tbody>
                        {
                          docsIds.map((entry) => {
                            const doc = docs.find((element) => (element.id === entry));
                            if (doc) {
                              return (
                                <tr key={entry}>
                                  <td>{doc.title}</td>
                                  <td>
                                    <S3Upload s3Key={doc.title} fileName={doc.title} />
                                  </td>
                                </tr>
                              );
                            }
                            return null;
                          })
                        }
                      </tbody>
                    </table>
                  </td>
                </tr>
                :
                null
            }

            <tr>
              <td className="biz-form-table-label" />
              <td colSpan={2}>
                <MuiButton variant="raised" color="primary" style={{ margin: '5px 0' }} onClick={this.handleFormSubmit}>
                  Submit
                </MuiButton>
              </td>
            </tr>

          </tbody>
        </table>
      </BizCard>
    );
  }
}

LdsFis.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      cid: PropTypes.string.isRequired,
    }),
  }).isRequired,
  fis: PropTypes.shape({
    id: PropTypes.number.isRequired,
    securitiesRequested: PropTypes.bool.isRequired,
    docsIds: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  docs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
  })).isRequired,
  mutate: PropTypes.func.isRequired,
};

export default graphql(MUTATION)(LdsFis);



// WEBPACK FOOTER //
// ./src/pages/leads/LdsFis.jsx